// extracted by mini-css-extract-plugin
export default {"emoji-icon":"Emojis_emoji-icon__MErDk"};